import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';

import {API} from "../../../../config";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {Button, MenuItem, Select} from "@material-ui/core";
import _ from "lodash";
import moment from "moment";

const investorNotes = API.service('investor-notes');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#6e6e6e',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class Notes extends Component {
    state={
        notes:[],
        note_action:'Note',
        note_note:'',
        note_username: this.props.context.username,
    };

    getNotes = () => {
        const app = this;

        investorNotes.find({query:{account:this.props.investor._account,$sort:{created_at:-1}}}).then(n=>{
            app.setState({
                notes:n.data,
            })
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            const app = this;
            this.setState({
                poid:[],
                poad:[],
            },app.getNotes());
        }
    }

    componentDidMount() {
        this.getNotes()
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state, error: '' }, event.target.id, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    handleActionChange = (event) => {
        this.setState({
            note_action: event.target.value
        });
    }

    saveNote = () => {
        const app = this;
        let payload = {
            account: this.props.investor._account,
            note: this.state.note_note,
            action: this.state.note_action,
            username: this.state.note_username
        }

        investorNotes.create(payload).then(n => {
            app.setState({
                notes:[n, ...this.state.notes]
            })
        })
    }

    render() {
        return (
            <React.Fragment>
                <div className={'flex'}>
                    <Paper className={'flex-1 mr-1'} style={{position:'relative', margin:5}}>

                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={"flex-1"}>
                                    Notes
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <div className="p-12">
                            <table style={{width:'100%'}} className={this.props.classes.stripedTable}>
                                <thead>
                                    <tr>
                                        <td style={{width:'150px'}}>Date</td>
                                        <td>Note</td>
                                        <td style={{width:'100px'}}>Action</td>
                                        <td style={{width:'200px'}}>Username</td>
                                        <td style={{width:'100px'}}>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className={this.props.classes.tableRow}>
                                        <td>{moment().format('Y-M-D')}</td>
                                        <td><textarea placeholder="Note" className="form-control w-full border p-1" type="text"
                                                      name="note_note" id="note_note" style={{height: '70px',marginTop:'7px'}} value={this.state.note_note} onChange={this.handleChange}/></td>
                                        <td>
                                            <Select
                                              value={this.state.note_action}
                                              onChange={this.handleActionChange}
                                              style={{
                                                  width: '100%'
                                              }}
                                              inputProps={{id: 'note_action',name: 'note_action'}}
                                            >
                                              <MenuItem value="Note">Note</MenuItem>
                                              <MenuItem value="Email">Email</MenuItem>
                                              <MenuItem value="Call">Call</MenuItem>
                                              <MenuItem value="Activity">Activity</MenuItem>
                                            </Select>
                                        </td>
                                        <td>{this.state.note_username}</td>
                                        <td><Button variant="contained" color="secondary" onClick={this.saveNote}>Add Note</Button></td>
                                    </tr>

                                    {this.state.notes.map((v,i)=>{
                                        return (
                                          <tr className={this.props.classes.tableRow}>
                                              <td>{moment(v.createdAt).format('Y-M-D HH:mm')}</td>
                                              <td>{v.note}</td>
                                              <td>{v.action}</td>
                                              <td>{v.username}</td>
                                              <td>&nbsp;</td>
                                          </tr>
                                        )}
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Paper>

                </div>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(Notes)));
